import { FeatureFlagStatusInterface } from '@galaxy/partner';
import { AI_ASSISTANT_VERSIONING, ASSISTANT_CONFIGURATION_V2 } from '../ai-assistant.constants';

/** The flags the redesigned list tiles and summary page are gated on, for a `batchGetStatus` call. */
export const CONFIGURATION_V2_FLAGS = [AI_ASSISTANT_VERSIONING, ASSISTANT_CONFIGURATION_V2];

/**
 * Whether the redesigned list tiles and the summary page are on. Both flags: the surfaces report version state,
 * so `assistant_configuration_v2` on its own would show version chrome to a partner without versioning.
 */
export function configurationV2Enabled(flags: FeatureFlagStatusInterface): boolean {
  return (flags[AI_ASSISTANT_VERSIONING] ?? false) && (flags[ASSISTANT_CONFIGURATION_V2] ?? false);
}
